import React from 'react';
import styled from 'styled-components';

const DotCSS = styled.div`
    display: contents;
    &::before {
        content: '';
        display: inline-block;
        min-width: 0.75rem;
        height: 0.75rem;
        // margin-right: 0.5rem;
        -moz-border-radius: 7.5px;
        -webkit-border-radius: 7.5px;
        border-radius: 7.5px;
        background-color: ${({ color }) => color}
    }
`

const Dot = ({ color, ...props }) => <DotCSS color={color} {...props} />

export default Dot;